module.exports = __webpack_public_path__ + "img/2.77bb3b5d.png";